import { Component, OnInit, ViewChild, ViewContainerRef,Input  } from '@angular/core';
import { NgForm } from '@angular/forms';
import { TemplateService } from '../template.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'template-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {
	public templates;
	public templateId;
	public templateById;
	public temp;
	public resultantArray;
	constructor(private templateService: TemplateService, public toastr: ToastsManager, vcr: ViewContainerRef,private router: Router) {
		this.templates =[];
		this.temp =[];
		this.resultantArray =[];
		this.templateService.fetchTemplates().subscribe(
										  (templates: any[]) => this.templates = templates,
										  (error) => console.log(error)
		);
	}
	templateNameBlur(event){
	}
	selected(event){
		this.templateId = event.item.id;
		this.templateService
		  .fetchTemplateById(this.templateId)
		  .subscribe(templateById => {
			this.templateById = templateById;
			if (this.templateById) {
				//let jsonFormattedString = this.templateById.templateData.replaceAll("\\\\", "");
				this.temp=[];
				this.temp.push({"id":this.templateById.id,"name":this.templateById.templateName});
			}
		  }, error => {
			
		  });
	}
	templateSubmit(){
		this.resultantArray = this.temp;
	}
	
	// for typeahead
	nameInputFormatter = (result: { name: string }) => result.name
	formatter = (result: { name: string }) => result.name
	searchByTemplate = (text$: Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .map(term => term.length < 2 ? []
        : this.templates.filter(v => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10));
	
	ngOnInit(): void {

	}
}



// WEBPACK FOOTER //
// ./src/app/system_setting/DFB/template/search/search.component.ts